var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.501 5.99976L15.4258 7.99976L10.501 9.99976L8.50098 14.9246L6.50098 9.99976L1.57715 7.99976L6.50098 5.99976L8.50098 1.07593L10.501 5.99976ZM4.20117 2.30054L5.83496 2.99976L4.20117 3.69995L3.50098 5.33374L2.80176 3.69995L1.16797 2.99976L2.80176 2.30054L3.50098 0.666748L4.20117 2.30054Z",
    fill: "url(#paint0_linear_9735_266402)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9735_266402",
    x1: 8.29688,
    y1: 0.666748,
    x2: 8.29688,
    y2: 14.9246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#853CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E01D5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.b8d521b64783b1acfe01345f890c4b16.svg";
export { ForwardRef as ReactComponent };